import { useMutation, useQueryClient } from "@tanstack/react-query";

import { customAxios } from "lib/axios";
import { refetchUserOnError } from "utils/refetchUserOnError";

export type UpdateUserNotificationPreferencesInput = {
  userId: string;
  preferences: {
    email?: boolean;
    phone?: boolean;
  };
};

type UpdateUserNotificationPreferencesResponse = {
  success: boolean;
  message?: string;
  data?: {
    _id: string;
    notificationPreferences: {
      email: boolean;
      phone: boolean;
    };
  };
};

const updateUserNotificationPreferences = async ({
  userId,
  preferences,
}: UpdateUserNotificationPreferencesInput): Promise<UpdateUserNotificationPreferencesResponse> => {
  const { data } = await customAxios.patch<UpdateUserNotificationPreferencesResponse>(
    `/users/${userId}/notification-preferences`,
    preferences
  );
  return data;
};

export const useUpdateUserNotificationPreferences = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateUserNotificationPreferences,
    onSuccess: async () => {
      // Refetch all scoped-users pages that might be visible/cached
      await queryClient.invalidateQueries({ queryKey: ["scoped-users"] });
      await queryClient.invalidateQueries({ queryKey: ["scopeUsers"] });
    },
    onError: (err) => {
      refetchUserOnError(err, queryClient);
    },
  });
};
